import { FC } from 'react';
import { InfoTable } from '@/components/info-table';
import { Button } from '@/components/ui/button';
import { strings } from '@/constants/strings';
import { DrawerContentLayout } from '@/layouts/drawer-content-layout';
import { Resident } from '@/types/resident';

export type ViewResidentProps = {
  resident: Resident;
  onClose: () => void;
  // onUnlink: () => void;
};

export const ViewResident: FC<ViewResidentProps> = ({
  resident,
  onClose,
  // onUnlink,
}) => (
  <DrawerContentLayout
    buttonItems={[
      // <Button key="unlink" variant="secondary-warning" onClick={onUnlink}>
      //   {strings.unit.residents.drawer_view.unlink_unit}
      // </Button>,
      <div className="flex-grow" key="flex"></div>,
      <Button key="close" onClick={onClose} variant="secondary">
        {strings.unit.residents.drawer_view.close}
      </Button>,
    ]}
    mainContent={
      <InfoTable
        rows={[
          { label: 'Name', value: resident.name },
          {
            label: 'Identifier',
            value: resident.identifier,
          },
          {
            label: 'External ID',
            value: resident.externalId,
          },
        ]}
        title="Resident Information"
      />
    }
  />
);
